import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { saasModernTheme } from 'common/theme/saasModern';

const StyledTableContainer = styled(TableContainer)(() => ({
  boxShadow: 'none',
  overflow: 'hidden',
  background: '#ffffff',
  border: 'none',
  marginBottom: 0,
}));

const GradientTableHead = styled(TableHead)(() => ({
  backgroundColor: saasModernTheme.defaultBackgroundColor,
  fontFamily: saasModernTheme.fontFamily,
  '& .MuiTableCell-head': {
    color: 'white',
    fontWeight: 600,
    fontSize: '16px',
    padding: '16px 24px',
    border: 'none',
    borderBottom: 'none',
  },
  '& .MuiTableCell-head:first-of-type': {
    paddingLeft: '34px',
  },
  '& .MuiTableCell-head:last-of-type': {
    paddingRight: '24px',
  },
}));

const GradientTableRow = styled(TableRow)(({ theme }) => ({
  backgroundColor: '#ffffff',
  '&:hover': {
    backgroundColor: '#f9f9fb',
  },
  cursor: (props) => (props.onClick ? 'pointer' : 'default'),
}));

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: '16px',
  padding: '16px 24px',
  borderBottom: '1px solid #f0f0f4',
  color: '#636F81',
  fontFamily: saasModernTheme.fontFamily,
  fontWeight: '400',
  '&:first-of-type': {
    paddingLeft: '34px',
  },
}));

const TableWrapper = styled(Box)(() => ({
  width: '100%',
  borderRadius: '12px',
  overflow: 'hidden',
  backgroundColor: '#ffffff',
}));

const BottomBorder = styled(Box)(() => ({
  height: '8px',
  background: saasModernTheme.defaultBackgroundColor,
  borderRadius: '0 0 12px 12px',
}));

const HeaderDivider = styled('div')(() => ({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  height: '20px',
  width: '2px',
  backgroundColor: '#ffffff',
}));

const STTableGradient = ({ columns, rows, width, onClickRow }) => {
  return (
    <TableWrapper sx={{ width: width || '100%', maxWidth: '100%' }}>
      <StyledTableContainer>
        <Table
          sx={{ width: '100%', borderCollapse: 'collapse' }}
          aria-label="simple table"
        >
          <GradientTableHead>
            <TableRow>
              {columns.map((header, index) => (
                <StyledTableCell
                  key={`header-${index}`}
                  align={header.align || 'left'}
                  sx={{
                    borderBottom: 'none',
                    color: 'white',
                    fontWeight: 600,
                    position: 'relative',
                  }}
                >
                  {header.component || header.title}
                  {index < columns.length - 1 && <HeaderDivider />}
                </StyledTableCell>
              ))}
            </TableRow>
          </GradientTableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <GradientTableRow
                key={`row-${rowIndex}`}
                onClick={() => onClickRow && onClickRow(row[0].id)}
                hover={!!onClickRow}
              >
                {row.map((cell, cellIndex) => (
                  <StyledTableCell
                    key={`cell-${rowIndex}-${cellIndex}`}
                    width={columns[cellIndex].width}
                    align={'left'}
                    sx={{
                      borderBottom:
                        rowIndex === rows.length - 1
                          ? 'none'
                          : '1px solid #f0f0f4',
                      color: '#637381',
                    }}
                  >
                    {cell.value}
                  </StyledTableCell>
                ))}
              </GradientTableRow>
            ))}
          </TableBody>
        </Table>
      </StyledTableContainer>
      <BottomBorder />
    </TableWrapper>
  );
};

export default STTableGradient;
